export function resolveCtfAdminMenuSelectedKeys(pathname: string): string[] {
  if (pathname === "/dashboard" || pathname === "/categories" || pathname === "/challenges" || pathname === "/artifact-releases") {
    return [pathname];
  }
  return [];
}
